// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__a-dln","newExpiryDate":"styles_newExpiryDate__1Nl0Z","footer":"styles_footer__2-G3X"};